import { CreateItemConversationArgs } from 'types/api/arguments/create-item-conversation-args'
import { CreateItemConversationResp } from 'types/api/response/create-item-conversation-resp'

import { api } from './api'

export const createItemConversationThread = ({
  itemId,
  initiator,
  receiverId,
}: CreateItemConversationArgs) =>
  api.post<CreateItemConversationResp>('/conversations', {
    initiator,
    item_id: itemId,
    opposite_user_id: receiverId,
  })
